<template>
    <div class="container">
        <div class="field">
            <p v-text="lang('L\'area e la localizzazione dell\'immobile sono necessari al fine di calcolare correttamente i costi di realizzazione e di trasporto')"></p>
        </div>
        <div>
          <div class="columns">
            <div class="column">
            <input-field :label="lang('Oggetto')" name="subject"
                         :errors="projectErrors"
                         v-model="input.subject"
                         required></input-field>
            </div>
          </div>
            <div class="columns">
              <div class="column">
                <select-fetch v-model="input.stage_development" :label="lang('Stato di sviluppo progetto')" name="stage_development"
                              :errors="projectErrors" :options="developmentStages" required></select-fetch>
              </div>
            </div>
            <div class="columns">
                <div class="column is-half">
                    <select-fetch v-model="input.type" :label="lang('Tipologia')"
                                  name="type" :errors="projectErrors" :options="types"></select-fetch>
                </div>
                <div class="column is-half">
                    <number-field :label="lang('Superficie (mq)')" name="area"
                                  :errors="projectErrors"
                                  v-model="input.area"
                                  min="25" :max="max"
                                  required></number-field>
                </div>
            </div>
            <div class="columns">
                <div class="column is-half">
                    <select-fetch v-if="language === 'it'" v-model="input.province" :label="lang('Provincia')" name="province"
                                  :options="provinces" :errors="projectErrors"></select-fetch>
                    <select-fetch v-else v-model="input.country" :label="lang('Paese')" name="province"
                                  :options="countries" :errors="projectErrors"></select-fetch>
                </div>
                <div class="column is-half">
                    <input-field :label="lang('Comune')" name="city"
                                 :errors="projectErrors"
                                 v-model="input.city"
                                 required></input-field>
                </div>
            </div>
        </div>
        <div v-if="type === 'request'" class="big-project">
            <textarea-field :label="lang('Descrizione')" name="description"
                            :errors="projectErrors"
                            v-model="input.description"
                            required></textarea-field>
            <div class="field">
                <p class="has-text-danger">
                    <small v-text="'* '+lang('Per la redazione del preventivo è necessario allegare la seguente documentazione: planimetria, sezione della copertura. In caso di mancato invio la richiesta non potrà essere presa in considerazione.')"></small>
                </p>
            </div>
        </div>
    </div>
</template>
<script>
    import FormErrors from "../Classes/FormErrors";

    export default {
        props: {
            value: {
                type: Object,
                required: false
            },
            type: {
                type: String,
                required: true
            },
            errors: {
                type: Object,
                required: true
            },
            provinces: {
                type: [Array, Object],
                required: true
            },
            countries: {
                type: [Array, Object],
                required: true
            },
            types: {
                type: [Array, Object],
                required: true
            },
            developmentStages: {
              type: [Array, Object],
              required: true
            }
        },
        data() {
            return {
                input: {
                    subject: '',
                    stage_development: '',
                    type: 1,
                    area: '',
                    province: 1,
                    country: 1,
                    city: '',
                    description: ''
                },
                completed: false,
                projectErrors: new FormErrors()
            }
        },
        mounted() {
            if (typeof this.value === 'object') this.input = this.value;
        },
        methods: {
            sendData() {
                this.checkComplete();
                this.$emit('input', this.input)
            },
            checkComplete() {
                let completed = true;
                for (let [key, val] of Object.entries(this.input)) {
                    if (key === 'description' && this.type === 'online') continue
                    if (val === '') completed = false;
                }
                this.completed = completed;
            }
        },
        computed: {
            max() {
                return (this.type === 'online') ? '200' : ''
            },
            language() {
                return window.language;
            }
        },
        watch: {
            completed(val) {
                if (val) this.$emit('completed')
            },
            input: {
                handler() {
                    this.sendData()
                },
                deep: true
            },
            errors: {
                handler(errors) {
                    if (errors.project) {
                        this.projectErrors.record(errors.project);
                    }
                }, deep: true
            }
        }
    }
</script>